import parsePhoneNumberFromString from 'libphonenumber-js';
import { z } from 'zod';

export const zPhoneRequired = z.string().transform((arg, ctx) => {
    const phone = validatePhone(arg);

    // when it's good
    if (phone) {
        return phone;
    }

    // when it's not
    ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Invalid phone number',
    });
    return z.NEVER;
});

/**
 * Validate a phone number.
 * @param phoneIn The phone number to validate.
 * @returns The validated phone number or null if invalid.
 */
export const validatePhone = (phoneIn: string) => {
    // Check for lazy entry.
    let dirtyInput = phoneIn.trim();
    if (dirtyInput.length == 8) {
        // Add 02
        dirtyInput = `02${dirtyInput}`;
    }

    const phone = parsePhoneNumberFromString(dirtyInput, {
        defaultCountry: 'AU',
        extract: false,
    });

    if (phone && phone.isValid()) {
        return phone.number;
    }

    return null;
}